import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axios from "axios";
import { ILocation, IProduct, ReactQueryKey } from "../../types";

export interface IGetCarsAvailabilitiesParams {
    pickupDate: string,
    dropoffDate: string,
    pickupLocation: ILocation,
    dropoffLocation: ILocation,
    carGroupCode: string,
    lockGroup: boolean,
    customerCode?: string | null,
    segment: string,
    products: IProduct[],
    rates: string[],
    tenant: string,
    dealer: string
}

export interface IGetCarsAvailabilitiesReturn {
    carAvailabilities: {
        code: string,
        label: string,
        availabilities: {
            date: string,
            availableCars: number,
            oneWayInS: {
                location: string,
                date: string,
                product: string
            }[],
            stopSells: {
                code: string,
                ruleName: string
            },
        }[]
    }[],
    locationAvailabilities: {
        code: string,
        label: string,
        availabilities: {
            date: string,
            availableCars: number,
            oneWayInS: {
                location: string,
                date: string,
                product: string
            }[],
            stopSells: {
                code: string,
                ruleName: string
            }
        }[]
    }[],
}


export const getCarsAvailabilities = async (params: IGetCarsAvailabilitiesParams): Promise<IGetCarsAvailabilitiesReturn> => {
    const response = await axios.post('/booking/instool/car-availability', params);
    return response.data;
};

export const useCarsAvailabilitiesQuery =  <TSelectData = IGetCarsAvailabilitiesReturn | null>(params?: IGetCarsAvailabilitiesParams, options?: UseQueryOptions<IGetCarsAvailabilitiesReturn | null, unknown, TSelectData>) => {
    return useQuery<IGetCarsAvailabilitiesReturn | null, unknown, TSelectData>(
        [ReactQueryKey.CarsAvailabilities, params],
        () => {
            if (params) {
                return getCarsAvailabilities(params)
            }
            return null;
        },
        options
    )
}
